const normalizeRole = (value) => String(value || "").toUpperCase();

export const isDriverMessage = (message) => {
  if (!message) return false;
  return normalizeRole(message.role) === "DRIVER";
};

export const isFleetMessage = (message) => {
  if (!message) return false;
  return normalizeRole(message.role) === "FLEET";
};
